export default __webpack_public_path__ + "static/media/13.67e21f5e.webp";